import { render, staticRenderFns } from "./TierFeatureCard.vue?vue&type=template&id=803db4a0&scoped=true&"
import script from "./TierFeatureCard.vue?vue&type=script&lang=js&"
export * from "./TierFeatureCard.vue?vue&type=script&lang=js&"
import style0 from "./TierFeatureCard.vue?vue&type=style&index=0&id=803db4a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803db4a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('803db4a0')) {
      api.createRecord('803db4a0', component.options)
    } else {
      api.reload('803db4a0', component.options)
    }
    module.hot.accept("./TierFeatureCard.vue?vue&type=template&id=803db4a0&scoped=true&", function () {
      api.rerender('803db4a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TierFeatureCard.vue"
export default component.exports